import SearchPartReplacementTable from '@/components/SearchParts/SearchPartDetails/SearchPartReplacementTable';
import { DefaultRouteTabs } from '@/components/_common';
import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { PageProps } from '@/types/PageProps';
import { Divider } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

const SearchPartReplacementPartsPage = ({ route }: PageProps) => {
  const intl = useIntl().formatMessage;

  const { partId } = useRouteMatch<{ partId: string }>().params;
  const basePath = `/app/searchParts/${partId}`;

  return (
    <DefaultRouteTabs route={route.parent} baseKey={partId} basePath={basePath}>
      <Helmet title={intl({ id: route.name })} />

      <SearchPartReplacementTable />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/searchParts" />
      </SpaceForButton>
    </DefaultRouteTabs>
  );
};

export default SearchPartReplacementPartsPage;
